import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowRight, MonitorDown } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import Callout from './Callout'

const DesktopCallout = () => {
  const { t } = useTranslation()

  return (
    <Callout
      icon={MonitorDown}
      title={t('homepage.desktop-title')}
      description={t('homepage.desktop-description')}
    >
      <Link
        to='/desktop'
        className={cn(buttonVariants({ variant: 'outline' }), 'gap-2')}
      >
        {t('homepage.desktop-link')}
        <ArrowRight className='h-4 w-4' />
      </Link>
    </Callout>
  )
}

export default DesktopCallout
